export default __webpack_public_path__ + "static/media/Olim7.632261a0.png";